document.addEventListener('DOMContentLoaded', () => {
  const toast = document.getElementById('cartToast');
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(window.__urbanhToast);
    window.__urbanhToast = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const data = new FormData(form);
      if (button) {
        button.disabled = true;
        button.dataset.original = button.textContent;
        button.textContent = 'Agregando...';
      }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        });
        if (!response.ok) throw new Error('Add to cart failed');
        await response.json();
        const cartResponse = await fetch('/cart.js', { headers: { 'Accept':'application/json' }});
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
        showToast('✓ Producto agregado al carrito');
      } catch (error) {
        window.location.href = form.action || '/cart';
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.original || 'Agregar al carrito';
        }
      }
    });
  });

  document.querySelectorAll('.qty-control').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelectorAll('[data-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.step || 1);
        const next = Math.max(0, Number(input.value || 0) + step);
        input.value = next;
      });
    });
  });
});